import Input from "components/FormComponents/Input/Input";

const GlobalFilter = ({ filterValue, setFilterValue }) => {
    const handleDataChange = (newValue) => {
        setFilterValue(newValue);
    };

    return (
        <Input
            className="xsd-global-search"
            id="global-filter__e2e-search-input"
            placeholder="Search..."
            label={"Search"}
            initialValue={filterValue}
            handleDataChange={handleDataChange}
            onEventType="onChange"
        />
    );
};

export default GlobalFilter;